module.exports = __webpack_public_path__ + "static/media/SWSCRC2-04.a5eea812.mp3";